import React, { PropTypes } from 'react';
const Flickity = require('react-flickity-component')(React);

import './style.scss';

const SubNavigation = props => {

  const flickityOptions = {
    accessibility: false,
    setGallerySize: false,
    prevNextButtons: false,
    pageDots: false,
    cellSelector: '.SubNavigationItem',
    percentPosition: false,
    contain: true // needed to fix desktop behaviour
  };

  return (

    <div className="SubNavigation">
      <div className="slides">
        <Flickity
          key={props.children.length}
          className={'carousel'}
          elementType={'span'}
          options={flickityOptions}
          disableImagesLoaded={false}>

          {props.children}
        </Flickity>
      </div>
    </div>

  );
};

SubNavigation.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ])
};

export default SubNavigation;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/SubNavigation/index.js
 **/